import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQS = [
  {
    q: "¿Qué es un no-show?",
    a: "Es una cita programada a la que el paciente no acude y que normalmente no puede ser ocupada por otra persona con tan poca antelación.",
  },
  {
    q: "¿La IA llama a todos los pacientes?",
    a: "No necesariamente. El flujo puede combinar WhatsApp, SMS, email y llamadas automáticas según las reglas de la clínica, el riesgo de ausencia y las preferencias disponibles.",
  },
  {
    q: "¿Qué ocurre si un paciente responde “creo que sí”?",
    a: "La IA detecta que no existe una confirmación clara, solicita una respuesta más concreta y puede escalar el caso a recepción.",
  },
  {
    q: "¿Puede la IA llenar una cancelación?",
    a: "Sí, puede identificar pacientes disponibles en una lista de espera y ofrecerles automáticamente una franja compatible, siempre que la configuración y las integraciones lo permitan.",
  },
  {
    q: "¿Sustituye al software dental?",
    a: "No. El objetivo es conectarse al calendario y al software existente para automatizar tareas administrativas sin sustituir el proceso clínico.",
  },
  {
    q: "¿Puede solicitar un depósito?",
    a: "Puede configurarse para solicitar un depósito o una tarjeta de garantía en citas determinadas, según las políticas de la clínica y la configuración del sistema.",
  },
  {
    q: "¿Cuánto dinero puede recuperar una clínica?",
    a: "Depende del volumen de citas, el precio medio de los tratamientos, la cantidad de no-shows, las cancelaciones y la capacidad para ocupar los huecos. La cifra de 2.000 € mensuales es una posibilidad orientativa, no una garantía.",
  },
  {
    q: "¿La IA sustituye a recepción?",
    a: "No. Reduce tareas repetitivas y avisa al equipo cuando una conversación requiere intervención humana.",
  },
];

export default function Faq() {
  return (
    <section id="faq" className="bg-white py-24 lg:py-32">
      <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <p className="text-sm font-semibold uppercase tracking-widest text-navy-light">
            Preguntas frecuentes
          </p>
          <h2
            data-testid="faq-title"
            className="mt-3 font-heading text-3xl font-extrabold tracking-tight text-navy sm:text-4xl"
          >
            Resolvemos tus dudas
          </h2>
        </div>

        <Accordion type="single" collapsible className="mt-12 space-y-3">
          {FAQS.map((faq, i) => (
            <AccordionItem
              key={faq.q}
              value={`faq-${i}`}
              data-testid={`faq-item-${i}`}
              className="rounded-xl border border-[#E8EDF5] bg-platinum/50 px-5 transition-colors duration-200 data-[state=open]:bg-white data-[state=open]:shadow-sm"
            >
              <AccordionTrigger
                data-testid={`faq-trigger-${i}`}
                className="py-5 text-left font-heading text-base font-bold text-navy hover:no-underline sm:text-lg"
              >
                {faq.q}
              </AccordionTrigger>
              <AccordionContent
                data-testid={`faq-content-${i}`}
                className="pb-5 text-sm leading-relaxed text-steel sm:text-base"
              >
                {faq.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
